import React from 'react';
import styled from 'styled-components';
import {Heading, Text, tokensForThemeProvider} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';

const tokens = tokensForThemeProvider.sky.sys;

/* A plain div rather than the DS FlexColumn: that component destructures `data-cy` and then never
 * renders it (FlexRow, confusingly, does forward it), so the Cypress hook below would silently never
 * reach the DOM. The layout it provided is two lines of CSS. */
const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	gap: ${tokens.spacing['200']};
	padding: ${tokens.spacing['800']} ${tokens.spacing['400']};
`;

/** Shown in place of the table when a run matched zero rows — which is not the same as a run that
 * failed, and is why this is separate from `ReportErrorState`.
 *
 * The copy deliberately names no conditions. An earlier version derived a list from the filter's field
 * paths ("your conditions may be too narrow: status, assignee"), which the design review replaced with
 * two fixed sentences; there is no field-path parsing left here, and no props to feed it.
 *
 * The same hint shows in both modes. A reader cannot in fact remove a condition, so the wording is
 * mildly off for them, but it is the copy the review agreed and a mode split is not worth
 * reintroducing to reword it. */
export function EmptyReportState(): JSX.Element {
	const {formatMessage} = useIntl();

	return (
		<Wrapper data-cy={'ai-report-builder-empty'}>
			<Heading size={'3'}>{formatMessage({id: 'ai_report_builder.empty.title'})}</Heading>
			<Text>{formatMessage({id: 'ai_report_builder.empty.hint'})}</Text>
		</Wrapper>
	);
}
